import React from "react";

// Currency → country, so we can show a real flag instead of a coloured dot.
const ISO = {
  USD: "us", QAR: "qa", AED: "ae", SAR: "sa", EUR: "eu", GBP: "gb", KWD: "kw", BHD: "bh",
  OMR: "om", TRY: "tr", INR: "in", EGP: "eg", JOD: "jo", PKR: "pk", BDT: "bd", LKR: "lk",
  PHP: "ph", IDR: "id", MYR: "my", JPY: "jp", CNY: "cn", HKD: "hk", SGD: "sg", CHF: "ch",
  CAD: "ca", AUD: "au", NZD: "nz", ZAR: "za", NGN: "ng", KES: "ke", MAD: "ma", TND: "tn",
  SEK: "se", NOK: "no", DKK: "dk", PLN: "pl", CZK: "cz", BRL: "br", MXN: "mx", KRW: "kr",
  THB: "th", VND: "vn", RUB: "ru", ILS: "il", IQD: "iq",
};

export const CurrencyFlag = ({ code, size = 32, className = "" }) => {
  const iso = ISO[(code || "").toUpperCase()];
  const style = { width: size, height: size };
  if (!iso) {
    return (
      <div style={style} data-testid={`currency-flag-${code}`}
        className={`rounded-full bg-secondary text-foreground/70 flex items-center justify-center text-[10px] font-bold ring-1 ring-black/5 ${className}`}>
        {(code || "").slice(0, 2)}
      </div>
    );
  }
  return (
    <img src={`https://flagcdn.com/w80/${iso}.png`} alt={`${code} flag`} loading="lazy" style={style}
      data-testid={`currency-flag-${code}`}
      className={`rounded-full object-cover ring-1 ring-black/10 shadow-sm ${className}`} />
  );
};
